<template>
  <v-layout column>
    <v-flex
      class="
        text-center
        font-weight-black
        mb-1
        text-caption text-lg-body-1 text-truncate
      "
    >
      {{ title }}
    </v-flex>
    <v-flex>
      <vc-donut
        :size="donutSize"
        :sections="[
          { value: data.totale.residuo, color: '#011ee9' },
          { value: data.totale.goduto, color: '#5eb0e1' },
        ]"
        :total="
          parseFloat((data.totale.residuo + data.totale.goduto).toFixed(2))
        "
      >
        <div class="text-little-6 text-lg-caption">
          Residuo
          {{ data.esposizGGHH === "G" ? "giorni" : "ore" }}:
          <span style="color: #011ee9">{{
            data.totale && data.totale.residuo | roundNumber
          }}</span>
          <br />
          Goduto
          {{ data.esposizGGHH === "G" ? "giorni" : "ore" }}:
          <span style="color: #5eb0e1">{{
            data.totale && data.totale.goduto | roundNumber
          }}</span>
        </div>
      </vc-donut>
    </v-flex>
    <v-flex
      class="text-center font-weight-black mb-1 text-caption text-lg-body-1"
    >
      Maturato
      {{ data.esposizGGHH === "G" ? "giorni" : "ore" }}:
      {{ data.totale && data.totale.maturato | roundNumber }}
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  name: "donut-chart",
  props: ["title", "data"],
  computed: {
    donutSize() {
      if (
        this.$vuetify.breakpoint.name == "lg" ||
        this.$vuetify.breakpoint.name == "xl"
      ) {
        return 150;
      }
      return 125;
    },
  },
};
</script>

<style></style>
